const auth = {
  LOGIN: "auth/login",
};

const project = {
  GET_PROJECTS: "api/v1/projects/items",
  CREATE_PROJECT: "api/v1/projects/item",
  UPDATE_PROJECT: "api/v1/projects/update-item",
  DELETE_PROJECT: "api/v1/projects/delete-item",
};

const variants = {
  VARIANT: "api/v1/projects/variant",
  GET_VARIANTS: "api/v1/projects/variants",
  REMOVE_APPS_FROM_VARIANT: "api/v1/projects/remove_apps_for_variant",
};

const downloads = {
  GET_APPS: "api/v1/downloads/items",
  GET_APP: "api/v1/downloads/item",
  GENERATE_DOWNLOAD_URL: "api/v1/downloads/generate_download_url",
};

const uploads = {
  GENERATE_UPLOAD_URL: "api/v1/uploads/generate_upload_url",
  ITEM: "api/v1/uploads/item",
  DELETE_ITEM: "api/v1/uploads/delete-item",
  GET_APPS_BY_PROJECT: "api/v1/uploads/items",
};

const apiPaths = {
  ...auth,
  ...project,
  ...variants,
  ...downloads,
  ...uploads,
};

export default apiPaths;
